import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('wo/inter-warehouse-transfer/drafts', { params })
  },

  async show (id) {
    return axios.get(`wo/inter-warehouse-transfer/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/inter-warehouse-transfer/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/inter-warehouse-transfer/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/inter-warehouse-transfer/drafts/${data.id}`, { data })
  }
}

export default DraftService
